
<template>
  <div class="share">
    <slot name="share">邀好友 赚收益</slot>
  </div>
</template>

<script>
export default {

}
</script>
<style  scoped>
.share {
  background: #FFC44C;
  color: #ffffff;
}
</style>